<script lang="ts">var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
import LinkAccountCard from "../LinkAccountCard/LinkAccountCard.svelte";
import { YinzCamCardsServiceElement } from 'yinzcam-cards';
import CardBase from '../../../common/CardBase.svelte';
import { findSource, findSourceStore } from '../../../utilities';
import { Readable } from 'svelte/store';
import { CardsDataSourceRegistration } from '../../../common/CardsDataSourceRegistration';
import { onMount } from 'svelte';
import { JanusSignonManagerToken, SSOResult } from "../../../../../js/sso";
import { getToken } from 'inversify-token';
import ROOT from '../../../../../inversify.config';
import { resolveUrl } from '../../../../../js/url';
import { ycSSOThirdPartyAuth } from '../../../../../js/ycapp';
import { f7 } from 'framework7-svelte';
import { isNil } from "lodash";
import { ycSSOSetState } from '../../../../../js/ycapp';
export let element;
export let sources;
export let sourceStore;
const signonManager = getToken(ROOT, JanusSignonManagerToken);
$: nbaConfig = ((_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.nbaConfig) || {};
$: sgConfig = ((_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.sgConfig) || {};
// Configurable text props
$: warningTitle = ((_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.warningTitle) || "You've linked different accounts";
$: warningText = ((_d = element === null || element === void 0 ? void 0 : element.data) === null || _d === void 0 ? void 0 : _d.warningText) || "Having different SeatGeek accounts linked can cause issues when accessing features in the Pelicans app.";
$: infoNbaId = ((_e = element === null || element === void 0 ? void 0 : element.data) === null || _e === void 0 ? void 0 : _e.infoNbaId) || "Link your SeatGeek account to your NBA ID account to access exclusive NBA content and offers.";
$: infoTeam = ((_f = element === null || element === void 0 ? void 0 : element.data) === null || _f === void 0 ? void 0 : _f.infoTeam) || "Link your SeatGeek account to your app account for access to your team membership and in-app benefits.";
$: infoSync = ((_g = element === null || element === void 0 ? void 0 : element.data) === null || _g === void 0 ? void 0 : _g.infoSync) || "Be sure to link the same SeatGeek account to your NBA ID and your App Account to avoid potential issues that can come with account links not being synced.";
$: teamLinkIcon = ((_h = element === null || element === void 0 ? void 0 : element.data) === null || _h === void 0 ? void 0 : _h.teamLinkIcon) || "/static/icons/icon-nba-team-generic.png";
$: teamLinkLabel = ((_j = element === null || element === void 0 ? void 0 : element.data) === null || _j === void 0 ? void 0 : _j.teamLinkLabel) || "Membership";
$: baseUri = (nbaConfig === null || nbaConfig === void 0 ? void 0 : nbaConfig.baseUri) || "https://auth-identity.nba.com";
$: clientIdParam = encodeURIComponent((nbaConfig === null || nbaConfig === void 0 ? void 0 : nbaConfig.clientId) || "");
$: redirectUri = (nbaConfig === null || nbaConfig === void 0 ? void 0 : nbaConfig.redirectUri) || "";
$: redirectUriParam = encodeURIComponent(redirectUri);
$: scopeParam = encodeURIComponent((nbaConfig === null || nbaConfig === void 0 ? void 0 : nbaConfig.scope) || "openid email profile");
$: linkSource = findSource($sources, 'YinzCamSignonServerLinks');
$: linkStore = linkSource === null || linkSource === void 0 ? void 0 : linkSource.store;
$: links = linkStore && [].concat($linkStore === null || $linkStore === void 0 ? void 0 : $linkStore.Link);
$: nbaLinked = (((links === null || links === void 0 ? void 0 : links.length) > 0) ? links.findIndex(l => (l === null || l === void 0 ? void 0 : l.Type) === 'NBAID') >= 0 : null) || false;
$: sgLinked = (((links === null || links === void 0 ? void 0 : links.length) > 0) ? links.findIndex(l => (l === null || l === void 0 ? void 0 : l.Type) === 'SEATGEEK') >= 0 : null) || false;
$: nbaProfileSource = findSource($sources, 'YinzCamSignonServerProfile', 'NBAID');
//$: console.log('nbaProfileSource', nbaProfileSource);
$: nbaProfileStore = nbaProfileSource === null || nbaProfileSource === void 0 ? void 0 : nbaProfileSource.store;
$: nbaProfileEntries = nbaProfileStore && ($nbaProfileStore === null || $nbaProfileStore === void 0 ? void 0 : $nbaProfileStore.Entry) || [];
//$: console.log('nbaProfileEntries', nbaProfileEntries);
$: sgIdFromNbaProfile = ((_k = nbaProfileEntries.find(e => (e === null || e === void 0 ? void 0 : e.Key) === 'sg_system_user_id')) === null || _k === void 0 ? void 0 : _k.Value) || null;
$: sgEmailFromNbaProfile = ((_l = nbaProfileEntries.find(e => (e === null || e === void 0 ? void 0 : e.Key) === 'sg_email')) === null || _l === void 0 ? void 0 : _l.Value) || null;
$: nbaLinkedToSg = ((_m = nbaProfileEntries.find(e => (e === null || e === void 0 ? void 0 : e.Key) === 'nba_linked')) === null || _m === void 0 ? void 0 : _m.Value) === 'true' || null;
$: sgProfileSource = findSource($sources, 'YinzCamSignonServerProfile', 'SEATGEEK');
//$: console.log('sgProfileSource', sgProfileSource);
$: sgProfileStore = sgProfileSource === null || sgProfileSource === void 0 ? void 0 : sgProfileSource.store;
$: sgProfileEntries = sgProfileStore && ($sgProfileStore === null || $sgProfileStore === void 0 ? void 0 : $sgProfileStore.Entry) || [];
//$: console.log('sgProfileEntries', sgProfileEntries);
$: sgIdFromSgProfile = ((_o = sgProfileEntries.find(e => (e === null || e === void 0 ? void 0 : e.Key) === 'seatgeek_crm_id')) === null || _o === void 0 ? void 0 : _o.Value) || null;
$: sgEmailFromSgProfile = ((_p = sgProfileEntries.find(e => (e === null || e === void 0 ? void 0 : e.Key) === 'email')) === null || _p === void 0 ? void 0 : _p.Value) || null;
$: nbaSgConnected = !!(nbaLinked && nbaLinkedToSg && sgIdFromNbaProfile);
//$: alert('nbaSgConnected: ' + nbaSgConnected + ', nbaLinked: ' + nbaLinked + ', nbaLinkedToSg: ' + nbaLinkedToSg + ', sgIdFromNbaProfile: ' + sgIdFromNbaProfile);
$: sgConnected = !!(sgLinked && sgIdFromSgProfile);
$: sgIdMismatch = nbaSgConnected && sgConnected && (sgIdFromNbaProfile !== sgIdFromSgProfile);
$: endWorkflow = (_q = element === null || element === void 0 ? void 0 : element.data) === null || _q === void 0 ? void 0 : _q.endWorkflow;
const refreshAllSources = (delayMillis, recurring = false) => {
    setTimeout(() => {
        if (!linkSource || !nbaProfileSource || !sgProfileSource) {
            return;
        }
        linkSource.refresh();
        nbaProfileSource.refresh();
        sgProfileSource.refresh();
        if (recurring) {
            refreshAllSources(delayMillis ? delayMillis * 1.5 : 500);
        }
    }, Math.max(500, Math.min(4000, delayMillis || 0)));
};
const onNbaConnect = () => __awaiter(void 0, void 0, void 0, function* () {
    if (!nbaSgConnected) {
        const codeVerifier = signonManager.generatePKCECodeVerifier();
        const challenge = yield signonManager.generatePKCEChallenge(codeVerifier);
        window.localStorage.setItem('NBAIDCodeVerifier', codeVerifier);
        const state = 'yinzcam';
        const tpaConfig = Object.assign({ url: `${baseUri}/oidc/authorize?client_id=${clientIdParam}&scope=${scopeParam}&response_type=code&redirect_uri=${redirectUriParam}&code_challenge=${challenge}&code_challenge_method=S256&state=${state}`, redirectUri }, ((!isNil(nbaConfig.ephemeral)) ? { ephemeral: nbaConfig.ephemeral } : undefined));
        ycSSOThirdPartyAuth("OAUTH", tpaConfig, (method, clientResult) => __awaiter(void 0, void 0, void 0, function* () {
            var _r, _s;
            console.log("ycSSOThirdPartyAuth callback inside OAUTH (NBAID)", method, clientResult);
            const codeVerifier = window.localStorage.getItem('NBAIDCodeVerifier');
            window.localStorage.removeItem('NBAIDCodeVerifier');
            if (clientResult === null || clientResult === void 0 ? void 0 : clientResult.error) {
                //alert(clientResult.error);
                console.error('Client Error: ' + clientResult.error);
                signonManager.fireWorkflowEndEvent();
                return;
            }
            if (!(clientResult === null || clientResult === void 0 ? void 0 : clientResult.redirectUri)) {
                console.warn(`ycSSOThirdPartyAuth callback for OAUTH (NBAID): missing redirectUri`);
                signonManager.fireWorkflowEndEvent();
                return;
            }
            const redirectParams = new URL(clientResult.redirectUri).searchParams;
            const checkState = redirectParams.get('state');
            if (checkState !== state) {
                alert("Missing or invalid NBA ID response.");
                signonManager.fireWorkflowEndEvent();
                return;
            }
            const code = redirectParams.get('code');
            if (!code || !codeVerifier) {
                alert("Missing or invalid NBA ID response.");
                signonManager.fireWorkflowEndEvent();
                return;
            }
            f7.preloader.show('white');
            let result = null;
            try {
                result = yield signonManager.loginWithNBAID(code, codeVerifier, redirectUri);
            }
            finally {
                f7.preloader.hide();
            }
            if (!(result === null || result === void 0 ? void 0 : result.success)) {
                alert(((_s = (_r = result === null || result === void 0 ? void 0 : result.data) === null || _r === void 0 ? void 0 : _r.UserMessage) === null || _s === void 0 ? void 0 : _s.Content) || 'An error occurred validating your NBA ID credentials.');
                signonManager.fireWorkflowEndEvent();
                return;
            }
            const existingAccount = result.data.AccountCreated !== 'true';
            ycSSOSetState(!existingAccount, result.data.YinzId, parseInt(result.data.ValidSpan), result.data.Ticket);
            refreshAllSources(500);
        }));
    }
    else {
        if (!confirm("Are you sure you want to unlink your SeatGeek account from your NBA ID?\n\nYou will no longer have continuous seamless access to your tickets and NBA ID benefits.")) {
            return;
        }
        let rsp = null;
        f7.preloader.show('white');
        try {
            rsp = yield signonManager.getCustomNbaIdUnlink('seatgeek');
        }
        finally {
            f7.preloader.hide();
        }
        if (!(rsp === null || rsp === void 0 ? void 0 : rsp.success)) {
            alert("Failed to unlink SeatGeek account.");
            return;
        }
        refreshAllSources(500);
    }
});
const onSgConnect = () => __awaiter(void 0, void 0, void 0, function* () {
    if (!sgConnected) {
        ycSSOThirdPartyAuth("SEATGEEK", sgConfig, (method, clientResult) => __awaiter(void 0, void 0, void 0, function* () {
            var _t, _u;
            console.log("ycSSOThirdPartyAuth callback inside SeatGeek", method, clientResult);
            if (!(clientResult === null || clientResult === void 0 ? void 0 : clientResult.accessToken)) {
                console.warn(`ycSSOThirdPartyAuth callback for ${method}: no access token in client result`);
                return;
            }
            let result = null;
            f7.preloader.show('white');
            try {
                result = yield signonManager.linkWithSeatGeekAccount(clientResult.accessToken, true);
            }
            finally {
                f7.preloader.hide();
            }
            if (result === null || result === void 0 ? void 0 : result.success) {
                if (endWorkflow) {
                    signonManager.fireWorkflowEndEvent();
                }
                else {
                    resolveUrl(`Connected?linkedImage=${encodeURIComponent('/static/icons/icon-seatgeek.png')}`).func();
                }
            }
            else {
                alert(((_u = (_t = result === null || result === void 0 ? void 0 : result.data) === null || _t === void 0 ? void 0 : _t.UserMessage) === null || _u === void 0 ? void 0 : _u.Content) || 'An error occurred.');
            }
        }));
    }
    else {
        resolveUrl(`DisconnectAccounts?accountType=${"seatgeek"}`).func();
    }
});
onMount(() => {
    refreshAllSources(500, true);
});
</script>

<style>.header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  line-height: 1.15;
}

.header .logo {
  width: 50px;
  margin-bottom: 4px;
}

.header .line1 {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
}

.header .line2 {
  font-size: 12px;
  text-align: center;
  margin-bottom: 16px;
  padding: 0 10px;
}

.link-info {
  font-size: 12px;
  text-align: center;
  line-height: 1.15;
  color: #8C959E;
  margin-top: 4px;
}

.warning-box {
  background: #fffbe6;
  border: 1.5px solid #ffe58f;
  color: #ad8b00;
  font-weight: bold;
  font-size: 13px;
  border-radius: 8px;
  padding: 10px 14px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(255, 215, 0, 0.08);
  gap: 8px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  gap: 4px;
}

.warning-icon {
  font-size: 18px;
  margin-right: 6px;
}

.warning-text {
  flex: 1;
}

.warning-title {
  font-weight: 700;
  font-size: 14px;
  margin-bottom: 2px;
  color: #ad8b00;
}</style>

<CardBase {element}>
    <div class="header">
       <img class="logo" src={"/static/icons/icon-seatgeek-nobg.png"} alt="SeatGeek" />
       <div class="line1">SeatGeek Account Connections</div>
       {#if sgIdMismatch}
           <div class="warning-box">
                <span class="warning-icon" aria-hidden="true">&#9888;&#65039;</span>
                <div class="warning-title">{warningTitle}</div>
                <div class="warning-text">{warningText}</div>
           </div>
       {:else}
           <div class="line2">{infoSync}</div>
       {/if}
    </div>
    <LinkAccountCard title='NBA ID' onConnect={onNbaConnect} image={"/static/icons/icon-nba-id.png"} email={sgEmailFromNbaProfile} connected={nbaSgConnected} {sources} />
    <div class="link-info">{infoNbaId}</div>
    <div style="height: 16px;"></div>
    <LinkAccountCard title={teamLinkLabel} onConnect={onSgConnect} image={teamLinkIcon} email={sgEmailFromSgProfile} connected={sgConnected} {sources} />
    <div class="link-info">{infoTeam}</div>
</CardBase>


